"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasureDropdown = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var sdk_model_1 = require("@gooddata/sdk-model");
var util_1 = require("@gooddata/util");
var DropdownButton_1 = require("../../Dropdown/DropdownButton");
var BubbleHoverTrigger_1 = require("../../Bubble/BubbleHoverTrigger");
var Bubble_1 = require("../../Bubble/Bubble");
var Dropdown_1 = require("../../Dropdown");
var getItems = function (intl, measures, measureNames, areaSortEnabled, availableId) {
    var measureValues = [];
    if (areaSortEnabled) {
        measureValues.push({
            id: "aggregation",
            title: intl.formatMessage({
                id: "sorting.sum.of.all.measure",
            }),
            localIdentifier: sdk_model_1.objRefToString(availableId),
        });
    }
    if (measures) {
        measures.map(function (measure) {
            var measureLocator = measure.locators.find(sdk_model_1.isMeasureLocator);
            var bucket = measureNames[measureLocator.measureLocatorItem.measureIdentifier];
            measureValues.push({
                id: measureLocator.measureLocatorItem.measureIdentifier,
                title: bucket === null || bucket === void 0 ? void 0 : bucket.name,
                sequenceNumber: bucket === null || bucket === void 0 ? void 0 : bucket.sequenceNumber,
                localIdentifier: measureLocator.measureLocatorItem.measureIdentifier,
            });
        });
    }
    return measureValues;
};
var getButtonValue = function (currentItem, intl, measureNames) {
    var _a, _b, _c;
    var buttonValue;
    if (sdk_model_1.isAttributeAreaSort(currentItem)) {
        buttonValue = {
            id: "aggregation",
            title: intl.formatMessage({ id: "sorting.sum.of.all.measure" }),
        };
    }
    else if (sdk_model_1.isMeasureSort(currentItem)) {
        var measureLocator = currentItem.measureSortItem.locators.find(sdk_model_1.isMeasureLocator);
        buttonValue = {
            id: (_a = measureNames[measureLocator.measureLocatorItem.measureIdentifier]) === null || _a === void 0 ? void 0 : _a.name,
            title: (_b = measureNames[measureLocator.measureLocatorItem.measureIdentifier]) === null || _b === void 0 ? void 0 : _b.name,
            sequenceNumber: (_c = measureNames[measureLocator.measureLocatorItem.measureIdentifier]) === null || _c === void 0 ? void 0 : _c.sequenceNumber,
        };
    }
    return buttonValue;
};
var getMeasureIconClassNameBySelected = function (id, enableRenamingMeasureToMetric) {
    if (id === "aggregation") {
        return "gd-icon-aggregation";
    }
    else if (enableRenamingMeasureToMetric) {
        return "gd-icon-metric";
    }
    else {
        return "gd-icon-measure";
    }
};
exports.MeasureDropdown = function (_a) {
    var currentItem = _a.currentItem, availableSorts = _a.availableSorts, bucketItemNames = _a.bucketItemNames, intl = _a.intl, onSelect = _a.onSelect, enableRenamingMeasureToMetric = _a.enableRenamingMeasureToMetric;
    var _b = tslib_1.__read(react_1.useState(0), 2), width = _b[0], setWidth = _b[1];
    var buttonRef = react_1.useRef();
    var measures = availableSorts.metricSorts;
    var areaSortEnabled = availableSorts.attributeSort.areaSortEnabled;
    var items = getItems(intl, measures, bucketItemNames, areaSortEnabled, availableSorts.itemId);
    var disableDropdown = items.length === 1;
    var buttonValue = getButtonValue(currentItem, intl, bucketItemNames);
    var measureName = buttonValue.sequenceNumber
        ? buttonValue.title + " (" + buttonValue.sequenceNumber + ")"
        : buttonValue.title;
    react_1.useEffect(function () {
        if (buttonRef && buttonRef.current) {
            setWidth(buttonRef.current.getBoundingClientRect().width);
        }
    }, []);
    var onMeasureSelectHandler = react_1.useCallback(function (item) {
        var direction = sdk_model_1.sortDirection(currentItem);
        if (item.id === "aggregation" && availableSorts.attributeSort.areaSortEnabled) {
            onSelect(sdk_model_1.newAttributeAreaSort(item.localIdentifier, direction));
        }
        else {
            onSelect(sdk_model_1.newMeasureSort(item.localIdentifier, direction));
        }
    }, [currentItem, onSelect]);
    return (react_1.default.createElement("div", { className: "sort-measure-section" },
        react_1.default.createElement("span", { className: "select-label" },
            react_1.default.createElement("span", null, "by")),
        react_1.default.createElement("div", { className: "measure-sorting-dropdown" }, disableDropdown ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(BubbleHoverTrigger_1.BubbleHoverTrigger, null,
                react_1.default.createElement(DropdownButton_1.DropdownButton, { className: "s-inner-aggregation-disabled-button s-inner-measure-dropdown-button", value: measureName, disabled: true, iconLeft: getMeasureIconClassNameBySelected(buttonValue.id, enableRenamingMeasureToMetric) }),
                react_1.default.createElement(Bubble_1.Bubble, { alignPoints: [{ align: "cr cl" }, { align: "cl cr" }] })))) : (react_1.default.createElement(Dropdown_1.Dropdown, { closeOnMouseDrag: true, closeOnParentScroll: true, renderButton: function (_a) {
                var isOpen = _a.isOpen, toggleDropdown = _a.toggleDropdown;
                return (react_1.default.createElement(BubbleHoverTrigger_1.BubbleHoverTrigger, null,
                    react_1.default.createElement("div", { ref: buttonRef },
                        react_1.default.createElement(DropdownButton_1.DropdownButton, { className: "s-sort-type-measure-button s-inner-measure-dropdown-button", value: measureName, isOpen: isOpen, disabled: disableDropdown, onClick: toggleDropdown, iconLeft: getMeasureIconClassNameBySelected(buttonValue.id, enableRenamingMeasureToMetric) })),
                    react_1.default.createElement(Bubble_1.Bubble, { alignPoints: [{ align: "cr cl" }, { align: "cl cr" }] })));
            }, renderBody: function (_a) {
                var closeDropdown = _a.closeDropdown;
                return (react_1.default.createElement(Dropdown_1.DropdownList, { width: width, items: items, className: "gd-measure-sorting-dropdown-body s-measure-sorting-dropdown-body", renderItem: function (_a) {
                        var item = _a.item;
                        var isSelected = item.title === buttonValue.title &&
                            item.sequenceNumber === buttonValue.sequenceNumber;
                        var className = classnames_1.default("gd-list-item", "gd-list-item-shortened", "gd-sorting-measure", "gd-button-link", getMeasureIconClassNameBySelected(item.id, enableRenamingMeasureToMetric), {
                            "is-selected": isSelected,
                        }, "s-sorting-measure-" + util_1.stringUtils.simplifyText(item.title));
                        return (react_1.default.createElement("div", { className: "gd-measure-dropdown-list" },
                            react_1.default.createElement("button", { className: className, onClick: function () {
                                    onMeasureSelectHandler(item);
                                    closeDropdown();
                                }, title: item.title },
                                react_1.default.createElement("span", { className: "gd-sorting-measure-title" }, item.title),
                                item.sequenceNumber ? (react_1.default.createElement("span", { className: "gd-sorting-sequence-number" }, item.sequenceNumber)) : null)));
                    } }));
            } })))));
};
//# sourceMappingURL=MeasureDropdown.js.map